// @flow

import React from 'react';
import {HelmetProvider} from 'react-helmet-async';
import {
  AccountProvider,
  AnalyticsProvider,
  ArticleProvider,
  ApiProvider,
  CookieProvider,
  LocationProvider,
  LocalizationProvider,
  NavigationProvider,
  PrefsProvider,
  RandomProvider,
  TimeProvider,
  SearchProvider,
  SidebarProvider,
  StorageProvider,
  XRayOverlayProvider,
  VideosProvider,
} from 'docs/data';
import type {InitialState} from 'docs/types';
import {Router} from 'docs/Router';
import StripeCluiProvider from './components/contrib/StripeClui/helpers/react/provider';
import {ContentFrameProvider} from './shell/content/ContentFrameProvider';
import {ContentAnimationProvider} from './shell/content/ContentAnimationProvider';
import './App.scss';

type Props = {|
  ...InitialState,
  helmetContext: Object,
|};

export const App = ({
  account,
  article,
  baseUrl,
  csrfToken,
  helmetContext,
  messages,
  navigation,
  prefs,
  requestId,
  routeMap,
  timestamp,
}: Props) => (
  <HelmetProvider context={helmetContext}>
    <RandomProvider seed={requestId}>
      <ApiProvider baseUrl={baseUrl} routeMap={routeMap} csrfToken={csrfToken}>
        <AccountProvider account={account}>
          <LocalizationProvider locale={account.locale} messages={messages}>
            <CookieProvider>
              <TimeProvider timestamp={timestamp}>
                <LocationProvider baseUrl={baseUrl} initialPath={article.path}>
                  <PrefsProvider prefs={prefs}>
                    <XRayOverlayProvider>
                      <NavigationProvider navigation={navigation}>
                        <ArticleProvider baseUrl={baseUrl} article={article}>
                          <SidebarProvider>
                            <VideosProvider>
                              <AnalyticsProvider requestId={requestId}>
                                <ContentFrameProvider>
                                  <ContentAnimationProvider>
                                    <SearchProvider>
                                      <StorageProvider>
                                        <StripeCluiProvider>
                                          <Router />
                                        </StripeCluiProvider>
                                      </StorageProvider>
                                    </SearchProvider>
                                  </ContentAnimationProvider>
                                </ContentFrameProvider>
                              </AnalyticsProvider>
                            </VideosProvider>
                          </SidebarProvider>
                        </ArticleProvider>
                      </NavigationProvider>
                    </XRayOverlayProvider>
                  </PrefsProvider>
                </LocationProvider>
              </TimeProvider>
            </CookieProvider>
          </LocalizationProvider>
        </AccountProvider>
      </ApiProvider>
    </RandomProvider>
  </HelmetProvider>
);
